import { render, staticRenderFns } from "./BankAccountList.vue?vue&type=template&id=33cc0120&scoped=true"
import script from "./BankAccountList.vue?vue&type=script&lang=js"
export * from "./BankAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc0120",
  null
  
)

export default component.exports